import { Reports } from '@/modules/reports/types';
import { Getters } from 'vuex-smart-module';
import ReportsRepairsState from './state';

export default class ReportsRepairsGetters extends Getters<ReportsRepairsState> {
  get report_request_date() {
    if (this.state.reports_dates) {
      return Object.keys(this.state.reports_dates).reduce((acc: Reports.ReportsDatesGetter[], year) => {
        const months = this.state.reports_dates[year];

        if (months?.length) {
          months.sort().forEach((month) => {
            acc.push({ year, month });
          });
        }

        return acc;
      }, []);
    }

    return [];
  }
}
